import React, { Component, Fragment } from "react";
import Label from "./Label";

// Must stay in step with NeuroPathwaysReferral::DOCUMENT_CONTENT_TYPES.
const DEFAULT_ACCEPT = ".pdf,.doc,.docx,.rtf,.jpg,.jpeg,.png";

// multi-file picker with client side allowlist checks - the server revalidates
// everything (including the real file content), this just gives people friendly
// feedback before they submit
class FileInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      // bump to clear the native input after each selection merge
      inputKey: 0
    };
  }

  allowedExtensions = () =>
    (this.props.accept || DEFAULT_ACCEPT)
      .split(",")
      .map(extension => extension.trim().toLowerCase());

  maxFiles = () => this.props.maxFiles || 10;

  maxFileSizeMb = () => this.props.maxFileSizeMb || 20;

  validFile = file => {
    const extension = `.${file.name.split(".").pop().toLowerCase()}`;
    if (!this.allowedExtensions().includes(extension)) {
      return `${file.name}: only ${this.allowedExtensions().join(", ")} files can be uploaded`;
    }
    if (file.size > this.maxFileSizeMb() * 1024 * 1024) {
      return `${file.name}: files must be ${this.maxFileSizeMb()}MB or smaller`;
    }
    return null;
  };

  handleChange = event => {
    const { files, onChange } = this.props;
    const selected = Array.from(event.target.files || []);
    const current = files || [];
    let error = null;
    const accepted = [];

    selected.forEach(file => {
      const fileError = this.validFile(file);
      if (fileError) {
        error = fileError;
      } else if (current.concat(accepted).length >= this.maxFiles()) {
        error = `You can upload a maximum of ${this.maxFiles()} files`;
      } else if (!current.some(existing => existing.name === file.name && existing.size === file.size)) {
        accepted.push(file);
      }
    });

    this.setState(prevState => ({ error, inputKey: prevState.inputKey + 1 }));
    if (accepted.length > 0) {
      onChange(current.concat(accepted));
    }
  };

  handleRemove = index => {
    const { files, onChange } = this.props;
    this.setState({ error: null });
    onChange((files || []).filter((_, i) => i !== index));
  };

  displaySize = bytes => {
    if (bytes >= 1024 * 1024) {
      return `${(bytes / (1024 * 1024)).toFixed(1)}MB`;
    }
    return `${Math.max(1, Math.round(bytes / 1024))}KB`;
  };

  render() {
    const { name, label, required, helpText, files } = this.props;
    const { error, inputKey } = this.state;
    const selectedFiles = files || [];

    return (
      <Fragment>
        <Label htmlFor={name} required={required} helpText={helpText}>
          {label}
        </Label>
        <input
          key={inputKey}
          className="form-control"
          id={name}
          name={name}
          type="file"
          multiple
          accept={this.props.accept || DEFAULT_ACCEPT}
          onChange={this.handleChange}
        />
        {error && <div className="text-danger">{error}</div>}
        {selectedFiles.length > 0 && (
          <ul className="list-group" style={{ marginTop: "10px" }}>
            {selectedFiles.map((file, index) => (
              <li key={`${file.name}-${index}`} className="list-group-item">
                {file.name} ({this.displaySize(file.size)}){" "}
                <button
                  type="button"
                  className="btn btn-danger btn-xs pull-right"
                  onClick={() => this.handleRemove(index)}
                >
                  Remove
                </button>
              </li>
            ))}
          </ul>
        )}
      </Fragment>
    );
  }
}

export default FileInput;
